<template>
	<div class="rel" style="height: 100%">
		<el-page-header @back="goBack" :content="dialogType=='add'?'新增流程':conditionForm.processName+ '编辑'"></el-page-header>
		<div class="flex">
			<div class="condition">
				<div class="item">
					<span>参考模板：</span>
					<el-select v-model="templateId" placeholder="请选择" filterable class="ipt" @change="temSelect" :disabled="isCheckUser">
						<el-option v-for="(item,index) in template" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</div>
				<div class="item">
					<span>流程名称：</span>
					<el-input class="ipt" v-model="conditionForm.processName" placeholder="请输入内容" :disabled="isCheckUser"></el-input>
				</div>
				<div class="item" v-if="dialogType=='edit'">
					<span>创建时间：</span>
					<el-date-picker
					:disabled="isCheckUser"
						class="ipt"
						v-model="conditionForm.processTime"
						type="date"
						placeholder="选择日期"
					></el-date-picker>
				</div>
				<div class="item">
					<span>类型：</span>
					<el-select
						v-model="conditionForm.processType"
						placeholder="请选择"
						class="ipt"
						:disabled="processList.length > 0 ? true : false"
					>
						<el-option label="采伐证审批" :value="1"></el-option>
						<el-option label="用火审批" :value="2"></el-option>
						<el-option label="事件处理" :value="3"></el-option>
					</el-select>
				</div>
				<div class="item" v-if="conditionForm.processType==3">
					<span>事件类型：</span>
					<el-select
					:disabled="isCheckUser"
						v-model="conditionForm.eventType "
						placeholder="请选择"
						class="ipt"
					>
						<el-option label="巡护上报" :value="1"></el-option>
						<el-option label="群众上报" :value="2"></el-option>
						<el-option label="内部上报" :value="3"></el-option>
						<el-option label="统一上报" :value="4"></el-option>
					</el-select>
				</div>
				<div class="item" v-if="conditionForm.processType==3||conditionForm.processType==1">
					<span>区域：</span>
					<el-select v-model="conditionForm.areaId" placeholder="请选择区域" class="ipt" :disabled="isCheckUser">
						<el-option v-for="(item,index) in zhen" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</div>
				<div class="item">
					<span>状态：</span>
					<el-select v-model="conditionForm.processState" placeholder="请选择" class="ipt" :disabled="isCheckUser">
						<el-option label="关闭" :value="0"></el-option>
						<el-option label="启用" :value="1"></el-option>
					</el-select>
				</div>
			</div>
			<div class="flex-sub text-center">
				<!-- 采伐证审批流程 -->
				<div class="processContent" v-if="conditionForm.processType==1">
					<el-scrollbar style="height: 100%" ref="scrollbar">
						<div class="design-engine" v-if="processList.length > 0">
							<div class="dingflow-design">
								<div class="ie-polyfill-container">
									<div class="box-scale" id="box-scale">
										<div class="node-wrap" v-for="(item, index) in processList2">
											<div class="node-wrap-box node_sid-startevent start-node">
												<div>
													<div class="arrows">
														<div class="title" :class="'node-type-' + item.nodeType">
															<span class="edit-title">{{ item.nodeTypeName }}</span>
															<i class="el-icon-close close" style="cursor: pointer;" @click="removeNode(index)"></i>
														</div>
													</div>
													<div class="content">
														<div>
															<div class="text" v-if="item.nodeType!=2">{{ item.userName }}</div>
															<div class="text" v-else>用户提交</div>
														</div>
														<span style="color: red;font-size: 12px;cursor: pointer;padding-left: 20px;" @click="editProcess(item,index)">编辑</span>
													</div>
												</div>
											</div>
											<div class="add-node-btn-box">
												<div class="add-node-btn">
													<el-button
														v-show="!isCheckUser"
														type="success"
														circle
														slot="reference"
														class="btn"
														icon="el-icon-plus"
														@click="openAddProcess(index)"
													></el-button>
												</div>
											</div>
										</div>
										<div class="end-node">
											<div class="end-node-circle"></div>
											<div class="end-node-text">流程结束</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div style="text-align: center;height: 650px;" @click="openAddProcess" v-else>
							<el-button type="success" circle icon="el-icon-plus"></el-button>
						</div>
					</el-scrollbar>
				</div>
				<!-- 事件流程 -->
				<div class="processContent" v-if="conditionForm.processType==3">
					<el-scrollbar style="height: 100%" ref="scrollbar">
						<div class="design-engine" v-if="processList.length > 0">
							<div class="dingflow-design">
								<div class="ie-polyfill-container">
									<div class="box-scale" id="box-scale">
										<div class="node-wrap" v-for="(item, index) in processList2">
											<div class="node-wrap-box node_sid-startevent start-node">
												<div>
													<div class="arrows">
														<div class="title" :class="'node-type-' + item.nodeType">
															<span class="edit-title">{{ item.nodeTypeName }}</span>
															<i class="el-icon-close close" style="cursor: pointer;" @click="removeNode(index)"></i>
														</div>
													</div>
													<div class="content">
														<div>
															<div class="text">{{item.nodeName}}</div>
															<div class="text margin-top-sm">{{ item.userName }}</div>
														</div>
														<span style="color: red;font-size: 12px;cursor: pointer;padding-left: 20px;" @click="editProcess(item,index)">编辑</span>
													</div>
												</div>
											</div>
											<div class="add-node-btn-box">
												<div class="add-node-btn">
													<el-button
													v-show="!isCheckUser"
														type="success"
														circle
														slot="reference"
														class="btn"
														icon="el-icon-plus"
														@click="openAddProcess(index)"
													></el-button>
												</div>
											</div>
										</div>
										<div class="end-node">
											<div class="end-node-circle"></div>
											<div class="end-node-text">流程结束</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div style="text-align: center;height: 650px;" @click="openAddProcess" v-else>
							<el-button type="success" circle icon="el-icon-plus"></el-button>
						</div>
					</el-scrollbar>
				</div>
				<div class="confirmAdd">
					<el-button type="success" @click="processConfirm" :loading="loading">确 定</el-button>
				</div>
			</div>
		</div>

		
		<!-- 新增采伐证节点 -->
		<el-dialog
			:title="title"
			:visible.sync="popoVisible"
			:modal="true"
			:close-on-click-modal="false"
			:close-on-press-escape="true"
			append-to-body
			@close="handleCloseDialog"
			width="30%"
		>
		<el-scrollbar style="height: 250px" ref="scrollbar">
			<el-form ref="infoForm" :model="infoForm" :rules="rules" label-width="80px" v-show="conditionForm.processType==1">
				<el-form-item label="操作类型" prop="type">
					<el-select v-model="infoForm.type" placeholder="请选择操作类型" :disabled="isCheckUser">
						<el-option
							v-for="item in operateTypeList"
							:key="item.flowchartNodeType"
							:label="item.flowchartNodeName"
							:value="item.flowchartNodeType"
							@click.native="labelClick(item.flowchartNodeName)"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="节点名称" prop="nodeName">
					<el-input v-model="infoForm.nodeName" placeholder="请输入节点名称" :disabled="isCheckUser" style="width: 50%;"></el-input>
				</el-form-item>
				<el-form-item label="处理人" v-if="infoForm.type!==2">
					<el-cascader ref="cascaderAddr" v-model="infoForm.operater" @change="operaterChange" :options="operaterList" placeholder="请选择处理人" :show-all-levels="false"></el-cascader>
				</el-form-item>
				<el-form-item>
					<el-button type="success" @click="addNode" v-if="title=='新增节点'">立即创建</el-button>
					<el-button type="success" @click="saveNode" v-else>保存</el-button>
					<el-button @click="handleCloseDialog">取消</el-button>
				</el-form-item>
			</el-form>
			<el-form ref="infoForm" :model="infoForm" :rules="rules" label-width="80px" v-show="conditionForm.processType==3">
				<el-form-item label="操作类型" prop="type">
					<el-select v-model="infoForm.type" placeholder="请选择操作类型" :disabled="isCheckUser">
						<el-option
							v-for="item in operateTypeList2"
							:key="item.flowchartNodeType"
							:label="item.flowchartNodeName"
							:value="item.flowchartNodeType"
							@click.native="labelClick(item.flowchartNodeName)"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="节点名称" prop="nodeName">
					<el-input v-model="infoForm.nodeName" :disabled="isCheckUser" placeholder="请输入节点名称" style="width: 50%;" ></el-input>
				</el-form-item>
				<el-form-item label="处理人">
					<el-cascader ref="cascaderAddr2" v-model="infoForm.operater" @change="operaterChange2" :options="operaterList" placeholder="请选择处理人" :show-all-levels="false" :props="props"></el-cascader>
				</el-form-item>
				<el-form-item>
					<el-button type="success" @click="addNode" v-if="title=='新增节点'">立即创建</el-button>
					<el-button type="success" @click="saveNode" v-else>保存</el-button>
					<el-button @click="handleCloseDialog">取消</el-button>
				</el-form-item>
			</el-form>
			</el-scrollbar>
		</el-dialog>
	</div>
</template>

<script>
import { GetTypeDic, AddFlowchart,GetDetails,UpdateFlowchart,GetEventFlowchartSelectionBox } from '@/api/Flowchart';
import { GetStaffByDepartmentId,GetDepartmentUser } from '@/api/staff.js';
import { GetDepartmentList } from '@/api/user.js';
import {GetAreaListByPId} from '@/api/area'
export default {
	name: 'addProcess',
	props: {
		/* 弹窗类型 */
		dialogType: {
		    type: String
		},
		// 模板数据
		template:{
			type:Array
		}
	},
	data() {
		return {
			props: { multiple: true },
			templateId:null,
			popoVisible: false,
			conditionForm: {
				processName: '',
				processTime: '',
				processType: 1,
				processState: 1,
				areaId:null,
				eventType:1
			},
			zhen:[],
			infoForm: {
				type: '',
				nodeName: '',
				operater: []
			},
			rules: {
				type: [{ required: true, message: '请选择操作类型', trigger: 'change' }],
				// operateDepartment: [{ required: true, message: '请选择处理部门', trigger: ['change'] }],
				nodeName: [{ required: true, message: '请输入节点名称', trigger: 'blur' }],
			},
			processList: [],
			processList2: [],
			operateTypeList: [],
			operateTypeList2:[{flowchartNodeName:'处理',flowchartNodeType:'2'}],//事件流程操作类型下拉
			operaterList: [],
			operater: '',
			operaterName:'',
			flowchartNodeName:'',
			currentIndex: 0,
			popoEventVisible:false,
			processID:null,
			title:'新增节点',
			operaterSelect:[],
			isCheckUser: false,
			loading:false,
		};
	},
	methods: {
		// 获取所有的乡镇
		getZhen(){
			GetAreaListByPId(0).then(res=>{
				if(res.data.state==1){
					this.zhen = res.data.data
				}
			})
		},
		// 获取工作人员根据部门Id
		operaterChange(e) {
			this.operaterSelect = []
			let arr = this.$refs['cascaderAddr'].getCheckedNodes()[0].pathLabels;
			this.operaterSelect = e
			this.operaterName = arr[arr.length - 1];
			this.operater = e[e.length - 1];
		},
		// 事件流程选择工作人员
		operaterChange2(e){
			let arr = this.$refs['cascaderAddr2'].getCheckedNodes(true);
			this.operaterSelect = e
			let Name = [] 
			let Code = []
			setTimeout(()=>{
				arr.forEach(item=>{
					if(item.checked==true){
						Name.push(item.label)
						Code.push(item.value)
					}
				})
					this.operaterName = Name.join(',')
					this.operater = Code.join(',')
			},200)
		},
		// 选择流程节点名称
		labelClick(label){
			this.flowchartNodeName = label
		},
		goBack() {
			this.processList = []
			this.processList2 = []
			this.infoForm = {
				type: '',
				nodeName: '',
				operater: []
			}
			this.conditionForm = {
				processName: '',
				processTime: '',
				processType: 1,
				processState: 1,
				areaId:null,
				eventType:1
			}
			this.flowchartNodeName = ''
			this.operateTypeList = [];
			this.operater = ''
			this.operaterName = ''
			this.currentIndex = 0;
			this.popoVisible = false;
			this.isCheckUser = false
			this.templateId = null
			this.$emit('close-dialog', false);
		},
		// 选择模板
		temSelect(){
			this.processList = []
			this.processList2 = []
			this.getProcessDetail(parseInt(this.templateId))
		},
		// 获取流程详情
		getProcessDetail(id,isCheckUser){
			this.processID = id
			if(isCheckUser){
				this.isCheckUser = true
			}else{
				this.isCheckUser = false
			}
			GetDetails(parseInt(id)).then(res=>{
				if(res.data.state==1){
					this.conditionForm.processName = res.data.data.flowchart.Name
					this.conditionForm.processTime = res.data.data.flowchart.Time
					this.conditionForm.processType = res.data.data.flowchart.FlowchartType
					this.conditionForm.processState = res.data.data.flowchart.State
					this.conditionForm.areaId = res.data.data.flowchart.AreaId
					this.conditionForm.eventType = res.data.data.flowchart.EventType
					res.data.data.flowchartNode.forEach(item=>{
						this.processList.push({
							nodeType: item.nodeType,
							nodeName: item.nodeName,
							userCode: item.userCode,
							id:item.id
						})
						this.processList2.push({
							nodeType: item.nodeType,
							nodeTypeName: item.nodeTypeName,
							nodeName: item.nodeName,
							operaterSelect:item.departmentTreeIds.length==0 ? item.eventDepartmentTreeIds : item.departmentTreeIds,
							userName: '处理人：' + item.userName,
							operaterName:item.userName,
							operater:item.userCode,
							id:item.id
						})
					})
				}
			})
		},
		/* 对话框取消按钮事件 */
		handleCloseDialog() {
			this.infoForm = {
				type: '',
				nodeName: '',
				operater: []
			}
			this.department = '';
			this.flowchartNodeName = ''
			// this.operateTypeList = [];
			this.operater = ''
			this.operaterName = ''
			this.currentIndex = 0;
			this.popoVisible = false;
			if(this.$refs.infoForm){
				this.$refs.infoForm.resetFields()
			}
			
			this.$data.infoForm=JSON.parse(JSON.stringify(this.$options.data().infoForm))
		},
		// 获取操作类型列表
		getOperateType() {
			GetTypeDic(this.conditionForm.processState).then(res => {
				if (res.data.state == 1) {
					this.operateTypeList = res.data.data;
				}
			});
			GetDepartmentUser().then(res => {
				this.operaterList = res.data.data;
			});
			// GetTypeDic(2).then(res=>{
			// 	this.operateTypeList2 = res.data.data;
			// })
		},
		// 打开采伐证新增节点框
		openAddProcess(index) {
			this.title = '新增节点'
			this.currentIndex = index;
			this.popoVisible = true;
		},
		// 新增节点本地
		addNode() {
			const that = this;
			this.$refs['infoForm'].validate(valid => {
				if (valid) {
					if(that.conditionForm.processType==1){
						if (!that.infoForm.operater && that.infoForm.type!==2) {
							return that.$message.error('请选择处理人');
						}
						that.processList.splice(that.currentIndex+1, 0, {
							nodeType: that.infoForm.type,
							nodeName: that.infoForm.nodeName,
							userCode: that.operater || ''
						});
						that.processList2.splice(that.currentIndex+1, 0, {
							nodeType: that.infoForm.type,
							nodeTypeName: that.flowchartNodeName,
							nodeName: that.infoForm.nodeName,
							operaterSelect:that.operaterSelect,
							userName: '处理人：' + that.operaterName,
							operaterName:that.operaterName
						});
						that.$message.success('添加成功');
						that.handleCloseDialog();
					}else if(that.conditionForm.processType==3){
						if (!that.infoForm.operater) {
							return that.$message.error('请选择处理人');
						}
						that.processList.splice(that.currentIndex+1, 0, {
							nodeType: that.infoForm.type,
							nodeName: that.infoForm.nodeName,
							userCode: that.operater
						});
						that.processList2.splice(that.currentIndex+1, 0, {
							nodeType: that.infoForm.type,
							nodeTypeName: that.flowchartNodeName,
							nodeName: that.infoForm.nodeName,
							operaterSelect:that.operaterSelect,
							userName: '处理人：' + that.operaterName,
							operaterName:that.operaterName
						});
						that.$message.success('添加成功');
						that.handleCloseDialog();
					}
					
				} else {
					return false;
				}
			});
		},
		// 打开编辑本地流程框
		editProcess(item,index){
			this.title = '编辑节点'
			this.currentIndex = index
			this.infoForm.type = item.nodeType
			this.infoForm.nodeName = item.nodeName
			this.infoForm.operater = item.operaterSelect
			this.infoForm.id = item.id
			this.flowchartNodeName = item.nodeTypeName
			this.operaterSelect = item.operaterSelect
			this.operaterName = item.operaterName
			this.operater = item.operater
			this.popoVisible = true
		},
		// 保存本地节点
		saveNode(){
			const that = this;
			this.$refs['infoForm'].validate(valid => {
				if (valid) {
					if(that.conditionForm.processType==1){
						if (!that.infoForm.operater && that.infoForm.type!==2) {
							return that.$message.error('请选择处理人');
						}
						that.processList.splice(that.currentIndex, 1, {
							nodeType: that.infoForm.type,
							nodeName: that.infoForm.nodeName,
							userCode: that.operater || '',
							id:that.infoForm.id
						});
						that.processList2.splice(that.currentIndex, 1, {
							flowchartType:that.conditionForm.processType,
							nodeType: that.infoForm.type,
							nodeTypeName: that.flowchartNodeName,
							nodeName: that.infoForm.nodeName,
							operaterSelect:that.operaterSelect,
							userName: '处理人：' + that.operaterName,
							id:that.infoForm.id
						});
						// that.$message.success('保存成功');
						that.handleCloseDialog();
					}else if(that.conditionForm.processType==3){
						if (!that.infoForm.operater) {
							return that.$message.error('请选择处理人');
						}
						that.processList.splice(that.currentIndex, 1, {
							nodeType: that.infoForm.type,
							nodeName: that.infoForm.nodeName,
							userCode: that.operater,
							id:that.infoForm.id
						});
						that.processList2.splice(that.currentIndex, 1, {
							flowchartType:that.conditionForm.processType,
							nodeType: that.infoForm.type,
							nodeTypeName: that.flowchartNodeName,
							nodeName: that.infoForm.nodeName,
							operaterSelect:that.operaterSelect,
							userName: '处理人：' + that.operaterName,
							operaterName:that.operaterName,
							id:that.infoForm.id
						});
						// that.$message.success('保存成功');
						that.handleCloseDialog();
					}
					
				} else {
					return false;
				}
			});
		},
		// 本地删除节点
		removeNode(index) {
			this.$confirm('确定删除？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.processList.splice(index, 1);
					this.processList2.splice(index, 1);
				})
				.catch(() => {});
		},
		// 流程提交到后台
		processConfirm() {
			const that = this;
			if (!that.conditionForm.processName) {
				return that.$message.error('请填写流程名称');
			}
			if (that.processList.length == 0) {
				return that.$message.error('请先添加流程节点再创建流程');
			}
			if (that.conditionForm.processType == 3 && !that.conditionForm.areaId) {
				return that.$message.error('请先选择区域再创建流程');
			}
			that.loading = true
			let params = {
				flowchartType: that.conditionForm.processType,
				name: that.conditionForm.processName,
				state: that.conditionForm.processState,
				nodeList: that.processList,
				areaId:that.conditionForm.areaId,
				eventType:that.conditionForm.eventType,
			};
			if(that.dialogType=='add'){
				AddFlowchart(params).then(res => {
					if (res.data.state == 1) {
						that.$message.success('操作成功');
						that.conditionForm = {
							processName: '',
							processTime: '',
							processType: 1,
							processState: 1,
							areaId:null,
							eventType:1
						}
						that.loading = false
						that.processList = []
						that.processList2 = []
						that.handleCloseDialog()
						that.$emit('dialog-confirm')
					}else{
						that.loading = false
					}
				})
			}else{
				params.id = that.processID
				UpdateFlowchart(params).then(res => {
					if (res.data.state == 1) {
						that.$message.success('操作成功');
						that.conditionForm = {
							processName: '',
							processTime: '',
							processType: 1,
							processState: 1,
							areaId:null,
							eventType:1
						}
						that.loading = false
						that.processList = []
						that.processList2 = []
						that.handleCloseDialog()
						that.$emit('dialog-confirm')
					}else{
						that.loading = false
					}
				})
			}
			
		}
	}
};
</script>

<style lang="less" scoped>
#drawProcessDesign {
	background: #f0f2f5;
}
.condition {
	margin-top: 30px;
	padding-left: 20px;
	display: flex;
	flex-direction: column;
	.item {
		flex: 1;
		display: flex;
		align-items: center;
		span {
			display: inline-block;
			text-align: right;
			width: 80px;
		}
		.ipt {
			width: 50% !important;
		}
	}
}
.processContent {
	// margin-top: 30px;
	.design-engine {
		position: relative;
		height: 100%;
		.dingflow-design {
			width: 100%;
			// background-color: #f5f5f7;
			overflow: auto;
			height: 100%;
			position: relative;
			bottom: 0;
			left: 0;
			right: 0;
			top: 0;
			/deep/ .ant-popover-arrow {
				display: none !important;
			}
			.ie-polyfill-container {
				display: -ms-grid;
				-ms-grid-columns: min-content;
				.box-scale {
					transform: scale(1);
					display: inline-block;
					position: relative;
					width: 100%;
					// padding: 54.5px 0;
					-webkit-box-align: start;
					-ms-flex-align: start;
					align-items: flex-start;
					-webkit-box-pack: center;
					-ms-flex-pack: center;
					justify-content: center;
					-ms-flex-wrap: wrap;
					flex-wrap: wrap;
					min-width: -webkit-min-content;
					min-width: -moz-min-content;
					min-width: min-content;
					// background-color: #f5f5f7;
					-webkit-transform-origin: 0 0 0;
					transform-origin: 50% 0px 0px;
					overflow: scroll;
					height: 550px;
					.node-wrap {
						display: inline-flex;
						flex-direction: column;
						-webkit-box-pack: start;
						-ms-flex-pack: start;
						justify-content: flex-start;
						-webkit-box-align: center;
						-ms-flex-align: center;
						align-items: center;
						-ms-flex-wrap: wrap;
						flex-wrap: wrap;
						-webkit-box-flex: 1;
						-ms-flex-positive: 1;
						width: 100%;
						// padding: 0 50px;
						position: relative;
						.node-wrap-box {
							display: -webkit-inline-box;
							display: -ms-inline-flexbox;
							display: inline-flex;
							-webkit-box-orient: vertical;
							-webkit-box-direction: normal;
							-ms-flex-direction: column;
							flex-direction: column;
							position: relative;
							// width: 220px;
							min-height: 72px;
							-ms-flex-negative: 0;
							flex-shrink: 0;
							background: #ffffff;
							border-radius: 4px;
							// cursor: pointer;
							.close {
								display: none;
								position: absolute;
								right: 10px;
								top: 50%;
								transform: translateY(-50%);
								width: 20px;
								height: 20px;
								font-size: 14px;
								color: #fff;
								border-radius: 50%;
								text-align: center;
								line-height: 20px;
							}
							&:hover {
								.close {
									display: block;
								}
								// &::after {
								//   border: 1px solid #3296fa;
								//   box-shadow: 0 0 6px 0 rgba(50, 150, 250, 0.3);
								// }
							}
							&::after {
								pointer-events: none;
								content: '';
								position: absolute;
								top: 0;
								bottom: 0;
								left: 0;
								right: 0;
								z-index: 2;
								border-radius: 4px;
								border: 1px solid transparent;
								transition: all 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
								box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
							}
							//审批
							.node-type-1 {
								background: rgb(87, 106, 149);
							}
							.node-type-2 {
								background: rgb(255, 148, 62);
							}
							.node-type-3 {
								background: rgb(255, 170, 255);
							}
							.node-type-4 {
								background: rgb(50, 150, 250);
							}
							.title {
								position: relative;
								display: flex;
								align-items: center;
								padding-left: 16px;
								padding-right: 30px;
								width: 100%;
								height: 24px;
								line-height: 24px;
								font-size: 12px;
								color: #ffffff;
								text-align: left;
								border-radius: 4px 4px 0px 0px;
								box-sizing: border-box;
								.edit-title {
									line-height: 15px;
									overflow: hidden;
									white-space: nowrap;
									text-overflow: ellipsis;
									border-bottom: dashed 1px transparent;
									&::before {
										content: '';
										position: absolute;
										top: 0;
										left: 0;
										bottom: 0;
										right: 40px;
									}
								}
							}
							.content {
								position: relative;
								font-size: 14px;
								padding: 16px;
								padding-right: 30px;
								display: flex;
								align-items: center;
								justify-content: space-between;
								.text {
									display: block;
									white-space: nowrap;
								}
							}
						}
						.add-node-btn-box {
							width: 240px;
							display: -webkit-inline-box;
							display: -ms-inline-flexbox;
							display: inline-flex;
							-ms-flex-negative: 0;
							flex-shrink: 0;
							-webkit-box-flex: 1;
							-ms-flex-positive: 1;
							position: relative;
							&::before {
								content: '';
								position: absolute;
								top: 0;
								left: 0;
								right: 0;
								bottom: 0;
								z-index: 0;
								margin: auto;
								width: 2px;
								height: 100%;
								background-color: #cacaca;
							}
							.add-node-btn {
								user-select: none;
								width: 240px;
								padding: 20px 0px 32px;
								display: flex;
								-webkit-box-pack: center;
								justify-content: center;
								flex-shrink: 0;
								-webkit-box-flex: 1;
								flex-grow: 1;
								.btn {
									position: relative;
									cursor: pointer;
									color: #fff;
									font-size: 16px;
									&:hover {
										transform: scale(1.3);
										box-shadow: 0 13px 27px 0 rgba(0, 0, 0, 0.1);
									}
									.iconfont {
										color: #fff;
										font-size: 16px;
									}
								}
							}
						}
					}

					.end-node {
						border-radius: 50%;
						font-size: 14px;
						color: rgba(25, 31, 37, 0.4);
						// text-align: left;
						width: 100px;
						position: relative;
						top: 10px;
						left: 50%;
						transform: translateX(-50%);
						.end-node-circle {
							width: 10px;
							height: 10px;
							margin: auto;
							border-radius: 50%;
							background: #dbdcdc;
						}
						.end-node-text {
							margin-top: 5px;
							text-align: center;
						}
					}
				}
			}
		}
	}
}
.confirmAdd{
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	padding:10px 0;
	text-align: center;
	box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.3);
}
// /deep/ .el-dialog__headerbtn .el-dialog__close {
// 	color:#fff!important;
// }
</style>
